import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantRiskService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateMerchantRiskMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({
			merchantId,
			fieldsData,
			onSuccess,
		}: {
			merchantId: string;
			fieldsData: {
				fieldBeName: string;
				fieldValue: Date | string | number | null | undefined;
			}[];
			onSuccess?: () => void;
		}) => {
			return merchantRiskService.updateMerchantRisk({
				merchantId,
				fieldsData,
			});
		},
		{
			onSuccess(data, { onSuccess }) {
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateMerchantRiskMutation;
